<div class="container-product-item">
  <div class="box-media">
    <product-media [product]="product"></product-media>
  </div>

  <div class="box-details">
    <p class="h4 text-primary" [innerHTML]="product.name"></p>

    <p *ngIf="product.partNumber" class="span">
      <span class="attr"> {{ 'intro.part' | cxTranslate }} #: </span>
      <span class="value"> {{ product.partNumber }} </span>
    </p>

    <p *ngIf="product.catalogNumber" class="span">
      <span class="attr"> {{ 'productRow.labels.catalog' | cxTranslate }} #: </span>
      <span class="value"> {{ product.catalogNumber }} </span>
    </p>
  </div>
</div>
